<template>
  <!--商品信息 -->
  <div id='bd-commodity'>
    <el-row v-for="message in commodityMessages" :key="message.mid"
      style="font-size: 10px; height: 60px; margin-top: 5px;">
      <el-col :span="24">
        <div style="float: left; margin-right: 10px;">
          <a style="color:blue;" :href="jsonObject(message.content).url" target="_blank">
            <img :src="jsonObject(message.content).imageUrl" style="width: 50px; height: 50px;" />
          </a>
        </div>
        <div>
          {{ $t('uuid') }}: {{ jsonObject(message.content).id }},
          {{ $t('categoryCode') }}: {{ jsonObject(message.content).categoryCode }},
          {{ $t('price') }}: {{ jsonObject(message.content).price }}
          {{ $t('timestamp') }}: {{ message.createdAt }}
        </div>
        <div>
          {{ $t('title') }}: {{ jsonObject(message.content).title }}, {{ $t('detail') }}: {{
          jsonObject(message.content).content }},
          <a style="color:blue;" :href="jsonObject(message.content).url" target="_blank">{{ $t("link") }}</a>
        </div>
        <div v-if="commodityMessages.length === 0" style="font-size: 15px; text-align:center;">
          {{ $t('noCommodityInfo') }}
        </div>
      </el-col>
      <hr>
    </el-row>
    <el-empty v-if="commodityMessages.length === 0" description="暂无商品信息"></el-empty>
    <el-button class="el-icon-refresh" size="mini" @click="getMessagesCommodity" style="margin-left: 30px;">{{ $t("refresh") }}</el-button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import * as https from '@/apis/http'
import bus from '@/util/eventbus'
const constants = require('@/util/constants')

export default {
  name: 'bd-commodity',
  data () {
    return {
      // 用户信息
      tags: [], //
      //
      inputVisible: false,
      inputValue: ''
    }
  },
  computed: {
    ...mapGetters([ 'userCurrentThread', 'commodityMessages', 'userCurrentCustomer' ]),
    nameTip () {
      return this.$t('name')
    },
    mobileTip () {
      return this.$t('mobile')
    },
    emailTip () {
      return this.$t('email')
    },
    companyTip () {
      return this.$t('company')
    },
    noteTip () {
      return this.$t('note')
    },
    tagTip () {
      return this.$t('tag')
    }
  },
  methods: {
    ...mapActions([ 'getMessagesCommodity' ]),
    jsonObject(content) {
      return content === null
        ? '{"categoryCode":"","content":"","id":0,"imageUrl":"","price":"","title":"","type":"commodity","url":""}'
        : JSON.parse(content);
    },
    showEditCrmDrawer () {
      // console.log('showEditCrmDrawer')
      bus.$emit(constants.EVENT_BUS_SHOW_CRM_DRAWER)
    },
    handleTagDelete (tagid) {
      console.log('handleTagDelete:', tagid)
      //
    },
    showTagInput () {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    handleInputConfirm () {
      console.log('handleInputConfirm:', this.inputValue)
      let tagName = this.inputValue
      if (tagName) {
        //
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    handleCommand (command) {
      this.$message('click on item ' + command)
    }
  }
}
</script>

<style scoped>
#bd-commodity {
  height: 100%;
  width: 100%;
  text-align: left;
}
li {
  list-style: none;
}
.bd-commodity-table {
  margin-top: 10px;
  margin-bottom: 10px;
  height: 100%;
  overflow-y: scroll !important;
}
.bd-user-tags {
  margin-top: 20px;
  margin-right: 5px;
}
.bd-input-new-tag{
  width:78px;
  margin-top: 20px;
  margin-left: 5px;
  vertical-align:bottom;
}
.bd-new-tag {
  margin-top: 20px;
  margin-left:10px;
}
</style>
